<template>
  <article class="subscription-loading">
    <section v-if="isLoading" class="loading-bg" />
    <div v-if="isLoading" class="preloader loading">
      <span class="slice" />
      <span class="slice" />
      <span class="slice" />
      <span class="slice" />
      <span class="slice" />
      <span class="slice" />
    </div>
  </article>
</template>

<script>
export default {
  name: 'SubscriptionLoading',
  props: {
    isLoading: Boolean
  }
}
</script>
